import ChevronDown from "@assets/images/chevron-down-2.svg";
import ChevronUp from "@assets/images/chevron-up-2.svg";
import iconRefresh from "@assets/images/refresh-primary.svg";
import {
  Box,
  Button,
  Collapse,
  FormControlLabel,
  Grid,
  GridSize,
  Radio,
  RadioGroup
} from "@material-ui/core";
import { FIELD_TYPE } from "@saleor/components/FormField/constants";
import MyTypography from "@saleor/components/MyTypography";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import React, { useState } from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

import ExcelUploadFile from "../UploadFile";
import useStyles from "./styles";
import useExcelUploadFilter from "./useExcelUploadFilter";

export interface IExcelUploadFilterProps {
  isOpen?: boolean;
}

const ExcelUploadFilter: React.FC<IExcelUploadFilterProps> = () => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const classes = useStyles();

  const { formik, formData } = useExcelUploadFilter();

  const renderItem = (
    <Grid className={classes.searchBox} container spacing={3}>
      {formData.map((child, key) => {
        const renderChild = (children: JSX.Element) => (
          <Grid
            item
            md={(child.md as GridSize) || 4}
            sm={(child.md as GridSize) || 6}
            key={key}
          >
            <MyTypography variant={"subtitle3"}>
              {child.title}
              {child.required && <span className={classes.required}>*</span>}
            </MyTypography>
            {children}
          </Grid>
        );
        if (child.type === FIELD_TYPE.SINGLE_SELECT) {
          return renderChild(
            <SingleSelectField
              className={classes.selectField}
              menuListCustomStyle={{
                overflowY: "auto"
              }}
              choices={child.options}
              name={child.name}
              onChange={formik.handleChange}
              value={formik.values[child.name]}
              placeholder={child.placeholder}
              error={!!formik.errors[child.name]}
            />
          );
        }

        if (child.type === FIELD_TYPE.RADIO_GROUP) {
          return renderChild(
            <RadioGroup
              className={classes.radioGroup}
              aria-labelledby="demo-controlled-radio-buttons-group"
              name={child.name}
              value={formik.values[child.name]}
              onChange={formik.handleChange}
            >
              {child.options.map((o, oKey) => (
                <FormControlLabel
                  key={`radio${oKey}`}
                  value={o.value}
                  control={<Radio />}
                  label={
                    <MyTypography variant={"body3"}>{o.label}</MyTypography>
                  }
                />
              ))}
            </RadioGroup>
          );
        }
      })}
    </Grid>
  );
  return (
    <Box className={classes.wrapper}>
      <Grid
        data-testid="collapse-container"
        className={classes.header}
        container
        onClick={() => setIsOpen(!isOpen)}
      >
        <MyTypography variant="h6">
          <FormattedMessage defaultMessage="Upload File" />
        </MyTypography>
        {isOpen ? <SVG src={ChevronUp} /> : <SVG src={ChevronDown} />}
      </Grid>
      <Collapse in={isOpen} className={classes.container}>
        <Grid className={classes.searchBox} container spacing={1}>
          <Grid container item xs={7} className={classes.leftSide}>
            {renderItem}
            <div style={{ marginLeft: "auto" }}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => formik.resetForm()}
                style={{ padding: "5px max(45px, 3vw)", marginRight: "22px" }}
              >
                <SVG src={iconRefresh} height={24} width={24} />
                <MyTypography variant="body3">ล้างข้อมูล</MyTypography>
              </Button>
            </div>
          </Grid>
          <Grid item xs={5} className={classes.rightSide}>
            <ExcelUploadFile formik={formik} />
          </Grid>
        </Grid>
      </Collapse>
    </Box>
  );
};

export default ExcelUploadFilter;
